import React, { useState, useContext, useEffect, Fragment } from 'react'
import { PageContext } from '../../Context/PageProvider'
import { makeStyles } from '@material-ui/core/styles'
import { DefaultStyles } from '../../Stylesheet/theme'
import { withTranslation } from 'react-i18next'
import { Grid, Select, Input, FormGroup, FormControlLabel, Checkbox, MenuItem, InputLabel, FormControl } from '@material-ui/core'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Modal from './Modal'


function PasswordModal({ t, userId, open, onClose }) {
    const classes = useStyles()
    const contex = useContext(PageContext)
    const api = contex.api
    const [password, setPassword] = useState(null)
    const [passwordVerify, setPasswordVerify] = useState(null)
    const [loading, setLoading] = useState(false)

    const onSubmit = async () => {
        try {
            setLoading(true)
            await api.adminService.updateUserPassword(userId, { password })
            setTimeout(() => {
                setLoading(false)
                setPassword(null)
                setPasswordVerify(null)
                onClose()
            }, 500)
        } catch (error) {
            console.log('Password Modal Error,', error)
        }
    }

    const onCancel = () => {
        setPassword(null)
        setPasswordVerify(null)
        onClose()
    }

    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        if (value !== password) {
            return false
        }
        return true
    })

    if (userId === null) return null
    return (
        <Modal open={open} aria-labelledby="password-modal" title={t('change_password')} onSubmit={onSubmit} onCancel={onCancel} loading={loading}>
            <Grid container>

                <Grid item className={classes.fields}>
                    <TextValidator
                        label={t('password')}
                        name="password"
                        type="password"
                        onChange={(event) => { const value = event && event.target && event.target.value; setPassword(value) }}
                        validators={['required']}
                        errorMessages={[t('this_field_is_required')]}
                        value={password}
                        disabled={loading}
                        autoFocus
                    />
                </Grid>
                <Grid item className={classes.fields}>
                    <TextValidator
                        label={t('repeat_password')}
                        name="passwordVerify"
                        type="password"
                        onChange={(event) => { const value = event && event.target && event.target.value; setPasswordVerify(value) }}
                        validators={['isPasswordMatch', 'required']}
                        errorMessages={[t('passwords_do_not_match'), t('this_field_is_required')]}
                        value={passwordVerify}
                        disabled={loading}
                    />
                </Grid>
            </Grid>
        </Modal >
    )
}

const useStyles = makeStyles(theme => ({
    fields: {
        ...DefaultStyles.ModalFields,
        marginBottom: theme.margin.medium,
        marginRight: 0
    }
}))

export default (withTranslation()(PasswordModal))